import { injectable, inject } from 'inversify';
import Request from '@framework/api/Rpc/Request';
import { type IRpcDispatcher } from '@evercall/json-rpc-dispatcher';
import DITypes from '@evercall/json-rpc-dispatcher/DITypes';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';

@injectable()
class EvercallDashboardExitRepository {
  constructor(
    @inject(DITypes.RpcDispatcher) private rpc: IRpcDispatcher,
  ) {}

  forceLogoutFromDashboard = async (
    payload: {
      dashboardId: string,
      corporateEmail: string,
    },
  ): Promise<null> => {
    const response = await this.rpc.call<RpcSuccess>(new Request('evercall.dashboard.exit', payload));

    return response.getResult().payload;
  };
}

export default EvercallDashboardExitRepository;
